import { render, staticRenderFns } from "./PointConfirmation.vue?vue&type=template&id=3c98ab5a&scoped=true"
import script from "./PointConfirmation.vue?vue&type=script&lang=js"
export * from "./PointConfirmation.vue?vue&type=script&lang=js"
import style0 from "./PointConfirmation.vue?vue&type=style&index=0&id=3c98ab5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98ab5a",
  null
  
)

export default component.exports